import React, { useEffect, useState } from 'react'

import Select from 'react-select'
import { QueryGetEmpreendimentos } from '../../../../graphql/services/Empreendimento'
import { QueryGetImoveis } from '../../../../graphql'

export function GetImoveisChosen({
  defaultValue,
  onChange
}) {
  let itensArray = []

  const [value, setValue] = useState(defaultValue)

  useEffect(() => {
    onChange(value)
  }, [value])

  const { data } = QueryGetImoveis({
    variables: {
      pagination: {
        pagina: 0,
        quantidade: 100,
      }
    }
  })



  if (!data) {
    return (
      <>
        <div className='form-group'>
          <label className='col-form-label'>Imóveis:</label>
          <Select
            options={itensArray}
            onChange={(e) => {
              setValue(e.value)
            }}
            value={itensArray.filter((e) => e.value)[0]}
            placeholder='Imóveis Disponiveis'
          />
        </div>
      </>
    )
  }
  itensArray.push({ value:'', label:'--selecione--'})
  data.GetImoveis.result.map((Options) => {
    itensArray.push({ value: Options.id, label: Options.nome })
    return []
  })



  return (
    <>
      <div className='form-group'>
        <label className='col-form-label'>Imóveis:</label>
        <Select
          options={itensArray}
          onChange={(e) => {
            setValue(e.value)
          }}
          placeholder='Imóveis Disponiveis'
        />
      </div>
    </>
  )
}
